import React, { useState, memo } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Qué incluye exactamente la colección?',
  answer: 'Recibís 7 recursos completos en un solo pack: 10 libros con +500 parábolas, una Biblia para colorear, un devocional familiar, un juego imprimible, tarjetas de versículos para memorizar, actividades cristianas y un cuaderno de oración guiado.'
}, {
  question: '¿Es un producto digital o físico?',
  answer: 'Es un producto 100% digital. No enviamos nada por correo físico. Esto te permite tener acceso inmediato y poder imprimir los materiales las veces que necesites.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Inmediatamente después de realizar el pago, recibirás un correo electrónico con el enlace para descargar toda la colección en tu computadora, tablet o celular.'
}, {
  question: '¿Puedo imprimirlo?',
  answer: '¡Sí, absolutamente! Todo el material está diseñado en alta calidad para que puedas imprimirlo en casa o en una gráfica, o bien usarlo directamente desde una pantalla.'
}, {
  question: '¿Sirve para usar en clases o solo en casa?',
  answer: 'Está pensado para ambos. Es una herramienta excelente tanto para padres en el hogar como para maestros de escuela dominical, catequistas y profesores de religión en el aula.'
}, {
  question: '¿Para qué edades es adecuado?',
  answer: 'El contenido está diseñado principalmente para niños, con un lenguaje claro y amoroso. Sin embargo, las reflexiones y actividades son fácilmente adaptables por padres y maestros para diferentes edades.'
}, {
  question: '¿Puedo usarlo con varios hijos o alumnos?',
  answer: 'Sí. Al ser un producto digital, podés imprimir las actividades, juegos y páginas para colorear todas las veces que necesites para tu uso personal, familiar o educativo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-16" style={{
    backgroundColor: 'var(--color-off-white)'
  }} data-id="element-109">
      <div className="container mx-auto px-4" data-id="element-110">
        <div className="max-w-3xl mx-auto" data-id="element-111">
          <FadeIn data-id="element-112">
            <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" style={{
            color: 'var(--color-deep-blue)'
          }} data-id="element-113">
              Preguntas frecuentes
            </h2>
          </FadeIn>

          <div className="space-y-3" data-id="element-114">
            {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-115">
                <div className="bg-white rounded-xl border overflow-hidden transition-shadow duration-200" style={{
              borderColor: openIndex === index ? 'var(--color-gold)' : 'var(--color-border)',
              boxShadow: openIndex === index ? '0 4px 12px rgba(201,150,59,0.08)' : '0 1px 2px rgba(0,0,0,0.04)'
            }} data-id="element-116">
                  <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-117">
                    <span className="text-base md:text-lg font-bold pr-4" style={{
                  color: 'var(--color-deep-blue)'
                }} data-id="element-118">
                      {faq.question}
                    </span>
                    <ChevronDown className="w-5 h-5 flex-shrink-0 transition-transform duration-300" style={{
                  color: openIndex === index ? 'var(--color-gold)' : 'var(--color-body)',
                  transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)'
                }} data-id="element-119" />
                  </button>
                  <div className="overflow-hidden transition-all duration-300 ease-in-out" style={{
                maxHeight: openIndex === index ? '200px' : '0px',
                opacity: openIndex === index ? 1 : 0
              }} data-id="element-120">
                    <p className="px-6 pb-5 text-base leading-relaxed font-medium" style={{
                  color: 'var(--color-body)'
                }} data-id="element-121">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}